import {Palette} from 'hubbl-shared';
import {AssetIconProps} from '../types';
import {memo} from 'react';

export const AssetIconKebabMenu = memo(
  ({size = 16, color = Palette.almostBlack}: AssetIconProps) => {
    return (
      <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M8.25 4.5C8.25 2.71079 9.71079 1.25 11.5 1.25C13.2892 1.25 14.75 2.71079 14.75 4.5C14.75 6.28921 13.2892 7.75 11.5 7.75C9.71079 7.75 8.25 6.28921 8.25 4.5ZM11.5 2.75C10.5392 2.75 9.75 3.53921 9.75 4.5C9.75 5.46079 10.5392 6.25 11.5 6.25C12.4608 6.25 13.25 5.46079 13.25 4.5C13.25 3.53921 12.4608 2.75 11.5 2.75ZM8.25 12C8.25 10.2108 9.71079 8.75 11.5 8.75C13.2892 8.75 14.75 10.2108 14.75 12C14.75 13.7892 13.2892 15.25 11.5 15.25C9.71079 15.25 8.25 13.7892 8.25 12ZM11.5 10.25C10.5392 10.25 9.75 11.0392 9.75 12C9.75 12.9608 10.5392 13.75 11.5 13.75C12.4608 13.75 13.25 12.9608 13.25 12C13.25 11.0392 12.4608 10.25 11.5 10.25ZM11.5 16.25C9.71079 16.25 8.25 17.7108 8.25 19.5C8.25 21.2892 9.71079 22.75 11.5 22.75C13.2892 22.75 14.75 21.2892 14.75 19.5C14.75 17.7108 13.2892 16.25 11.5 16.25ZM9.75 19.5C9.75 18.5392 10.5392 17.75 11.5 17.75C12.4608 17.75 13.25 18.5392 13.25 19.5C13.25 20.4608 12.4608 21.25 11.5 21.25C10.5392 21.25 9.75 20.4608 9.75 19.5Z"
          fill={color}
        />
      </svg>
    );
  },
);
